module.exports = __webpack_public_path__ + "static/media/mapLayerv2.0f99394e.png";